const O = "open", L = "closed", n = "closed_temporarily", t = "opening_soon", S = [O, L, n, t], A = S.filter((o) => o !== L).join(",");
var E = /* @__PURE__ */ ((o) => (o.LOCAL = "LOCAL", o.GLOBAL = "GLOBAL", o))(E || {});
export {
  A as ALL_STATUSES_EXCEPT_CLOSED,
  E as BusinessReachEnum,
  L as CLOSED,
  n as CLOSED_TEMPORARILY,
  O as OPEN,
  t as OPENING_SOON,
  S as STATUSES
};
